import { useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { Droppable } from "react-beautiful-dnd";
import { AiOutlineClose } from "react-icons/ai";
import { CgCompress } from "react-icons/cg";
import { FaCheck, FaPlus, FaTimes } from "react-icons/fa"; // Import icons
import { LuGripVertical } from "react-icons/lu";
import { SlOptions } from "react-icons/sl";
import styled from "styled-components";
import { OutsideClick } from "../../../Components";
import { ErrorToast, SuccessToast, WarningToast } from "../../../Components/ToastComponent/RectHotToast";
import {
  CREATE_TASK_TO_BOARD,
  EDIT_COLUMN_IS_COLLAPSED,
  EDIT_TASK_MANAGEMENT_COlUMN_NAME,
  GET_ALL_TASKS,
} from "../utils/quires";
import Task from "./Task";
import "./scroll.scss";
import { useEventListener } from "usehooks-ts";

function Column({ column, tasks, isCollapsed, BoardId, haandleOpenDeleteColumn, handleEditTask }) {
  const [collapsed, setCollapsed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [EDIT_COLUMN_NAME] = useMutation(EDIT_TASK_MANAGEMENT_COlUMN_NAME, {
    onCompleted: () => {
      SuccessToast("Column name updated successfully!");
    },
    onError: (err) => {
      ErrorToast("Failed to update column name: " + err.message);
    },
    refetchQueries: [
      {
        query: GET_ALL_TASKS,
        variables: {
          userInput: {
            Board_ID: BoardId,
            User: [],
            keyword: "",
          },
        },
        fetchPolicy: "network-only",
      },
    ],
  });
  const [Create_Task_To_column] = useMutation(CREATE_TASK_TO_BOARD, {
    onCompleted: () => {
      SuccessToast("Task Created successfully!");
    },
    onError: (err) => {
      ErrorToast("Failed to update column name: " + err.message);
    },
    refetchQueries: [
      {
        query: GET_ALL_TASKS,
        variables: {
          userInput: {
            Board_ID: BoardId,
            User: [],
            keyword: "",
          },
        },
        fetchPolicy: "network-only",
      },
    ],
  });
  const [Edit_columnCollapsed] = useMutation(EDIT_COLUMN_IS_COLLAPSED);
  const [isAdding, setIsAdding] = useState(false);
  const [newTaskContent, setNewTaskContent] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [columnTitle, setColumnTitle] = useState(column.Title);
  const [showOptions, setShowOptions] = useState(false);

  const createInputRef = useRef();

  useEffect(() => {
    setCollapsed(isCollapsed);
  }, [isCollapsed]);
  const toggleEdit = () => setIsEditing(!isEditing);

  // Function to handle keyboard events
  const handleKeyDown = async (event) => {
    if (event.key === "Escape" && isAdding) {
      handleCloseNewTask();
    } else if (event.key === "Enter" && !event.shiftKey && isAdding) {
      event.preventDefault(); // Prevent default Enter key behavior
      await handleAddNewTask();
      setIsAdding(true);
      setTimeout(() => {
        createInputRef?.current?.focus();
      }, 100);
    }
  };

  // Use the useEventListener hook from usehooks-ts to listen for keydown events
  useEventListener("keydown", handleKeyDown);

  const handleChangeTitle = (e) => {
    setColumnTitle(e.target.value);
  };

  const handleSaveEdit = () => {
    EDIT_COLUMN_NAME({
      variables: {
        editColumnInBoardId: BoardId,
        userInput: {
          Title: columnTitle,
          _id: column._id,
        },
      },
    });
    setIsEditing(false);
    // Implement the save logic
  };

  const Collapse_Trigger = () => {
    setCollapsed(!isCollapsed);
    Edit_columnCollapsed({
      variables: {
        editColumnCollapsedId: BoardId,
        userInput: {
          Is_Collapsed: !isCollapsed,
          _id: column._id,
        },
      },
    });
  };
  const handleToggleOptions = () => {
    setShowOptions(!showOptions);
  };

  const handleRename = () => {
    // Logic to handle rename
    setShowOptions(false);
    toggleEdit();
  };

  const handleDelete = () => {
    // Logic to handle delete
    haandleOpenDeleteColumn(column._id);
    setShowOptions(false); // Hide options menu
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    // setColumnTitle(column.title);
  };

  const handleOpenNewTask = () => setIsAdding(true);
  const handleCloseNewTask = () => {
    setIsAdding(false);
    setNewTaskContent("");
  };
  const handleNewTaskContentChange = (e) => setNewTaskContent(e.target.value);
  const handleAddNewTask = async () => {
    // Logic to add a new task will go here
    if (newTaskContent.trim() === "") {
      WarningToast("Please Add Card Title");
      return; // Prevent adding empty tasks
    }
    // Prevent multiple submissions
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await Create_Task_To_column({
        variables: {
          createInput: {
            Board_ID: BoardId,
            Column_ID: column._id,
            Title: newTaskContent,
            Serial_No: tasks?.length || 0,
          },
        },
      });

      // Resetting the state
      setNewTaskContent("");
      setIsAdding(false);
    } catch (error) {
      // Handle any errors if needed
      console.error("Failed to create task:", error);
    } finally {
      setIsSubmitting(false); // Re-enable the button after submission
    }
  };

  if (collapsed.toString() === "true") {
    return (
      <CollapsedHeader onClick={() => Collapse_Trigger(column?.id)}>
        <LuGripVertical />
        <CollapsedTitle>
          {column?.Title}
          {`  (${tasks?.length || 0})`}
        </CollapsedTitle>
        <CgCompress onClick={() => Collapse_Trigger(column?.id)} style={{ cursor: "pointer", rotate: "45deg" }} />
        {/* Include other icons as necessary */}
      </CollapsedHeader>
    );
  }
  return (
    <Container className="column">
      <Header>
        {isEditing ? (
          <HeaderInputBox>
            <TitleEditInput value={columnTitle} onChange={handleChangeTitle} autoFocus />
            <EditButtons>
              <IconButton onClick={handleCancelEdit}>
                <FaTimes size={14} />
              </IconButton>
              <IconButton onClick={handleSaveEdit}>
                <FaCheck size={14} />
              </IconButton>
            </EditButtons>
          </HeaderInputBox>
        ) : (
          <>
            <LuGripVertical />
            <Title onDoubleClick={toggleEdit}>
              {column.Title} {`  (${tasks?.length || 0})`}
            </Title>
            <IconsWrapper>
              <CgCompress onClick={() => Collapse_Trigger(column?.id)} style={{ margin: "0 8px" }} />

              {/* Add your rename and delete options here */}
            </IconsWrapper>
            <IconButton onClick={handleOpenNewTask} style={{ marginRight: "5px" }}>
              <FaPlus size={14} />
            </IconButton>
            <SlOptions onClick={handleToggleOptions} />
            <OutsideClick setToggled={setShowOptions}>
              <OptionsMenu show={showOptions}>
                <OptionItem onClick={handleRename}>Rename</OptionItem>
                <OptionItem onClick={handleDelete}>Delete</OptionItem>
              </OptionsMenu>
            </OutsideClick>
          </>
        )}
      </Header>
      <TaskList className="task-list-container">
        {isAdding && (
          <NewTaskForm>
            <NewTaskInput
              id="task-create-container"
              ref={createInputRef}
              placeholder="Enter a title for this card..."
              value={newTaskContent}
              onChange={handleNewTaskContentChange}
              autoFocus
            />
            <NewTaskButtons>
              <AddTaskButton onClick={handleAddNewTask} disabled={isSubmitting}>
                Add card
              </AddTaskButton>
              <CloseButton onClick={handleCloseNewTask}>
                <AiOutlineClose />
              </CloseButton>
            </NewTaskButtons>
          </NewTaskForm>
        )}
        <Droppable droppableId={column._id} type="task">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{
                background: snapshot.isDraggingOver ? "lightblue" : "inherit",
                // padding: 3,
                minHeight: 500,
              }}
            >
              {tasks?.map((task, index) => (
                <Task
                  key={task._id}
                  task={task}
                  index={index}
                  handleEditTask={handleEditTask}
                  Task_Code={task.Task_Code}
                  Priority={task.Priority}
                  Assignee={task.Assignee?.Full_Name}
                  Due_Date={task.Due_Date}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </TaskList>
    </Container>
  );
}

export default Column;

// Styled Components
const Container = styled.div`
  background-color: #ebecf0;
  border-radius: 2px;
  width: 290px;
  /* margin-right: 20px; */
  display: flex;
  flex-direction: column;
`;

const TaskList = styled.div`
  /* padding: 8px; */
  height: 70dvh; // Adjust this height based on your design needs
  max-height: 70dvh;
  overflow-y: auto;
  /* margin-left: 3px; */
  margin: 5px;
  // Hide scrollbar for Chrome, Safari and Opera
  &::-webkit-scrollbar {
    display: none;
  }

  // Hide scrollbar for IE, Edge and Firefox
  -ms-overflow-style: none; // IE and Edge
  scrollbar-width: none; // Firefox
`;

// const AddCardButton = styled.button`
//   background: transparent;
//   border: none;
//   color: #5e6c84;
//   padding: 10px 8px;
//   width: 100%;
//   text-align: left;
//   cursor: pointer;
//   &:hover {
//     background: #dfe1e6;
//   }
// `;

const NewTaskForm = styled.div`
  padding: 10px;
  background: #ffffff;
  margin: 4px;
`;

const NewTaskInput = styled.textarea`
  width: 100%;
  //   padding: 8px;
  border: none;
  //   border-radius: 3px;
  // width:98%:
  resize: none;
  margin-bottom: 8px;
  &:focus {
    outline: none;
    border-color: transparent;
    box-shadow: none;
  }
`;

const NewTaskButtons = styled.div`
  display: flex;
  justify-content: space-between;
`;

const AddTaskButton = styled.button`
  background-color: #5aac44;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 3px;
  cursor: pointer;
  &:hover {
    background-color: #61bd4f;
  }
`;

const CloseButton = styled.button`
  font-size: 24px;
  line-height: 20px;
  color: #6b778c;
  cursor: pointer;
  border: none;
  background: transparent;
  &:hover {
    color: #172b4d;
  }
`;

const Header = styled.div`
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative; /* Needed for absolute positioning of icons */
`;

const IconsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  opacity: 0; /* Icon is invisible initially */
  transition: opacity 0.2s ease;

  ${Header}:hover & {
    opacity: 1; /* Icon becomes visible when header is hovered */
  }
`;

const Title = styled.div`
  padding: 8px;
  font-weight: bold;
  flex-grow: 1; /* Ensures the title takes the available space pushing icons to the end */
  &:hover {
    cursor: pointer;
  }
`;

const TitleEditInput = styled.input`
  font-size: 1rem;
  font-weight: bold;
  padding: 8px;
  border: 1px solid #dfe1e6;
  border-radius: 3px;
  width: calc(100% - 16px); /* Account for padding */
  box-sizing: border-box;
  &:focus {
    outline: none;
    border: 2px solid #388bff;
    box-shadow: none;
  }
`;

const EditButtons = styled.div`
  display: flex;
  align-items: center;
  margin-left: 150px; // Space from input box
`;

const IconButton = styled.button`
  border: none;
  color: #42526e;
  background: #ffffff;
  border-radius: 3px;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 4px; // Space between buttons
  box-shadow: 0 2px 0 rgba(9, 30, 66, 0.25);

  &:hover {
    background-color: #ebecf0;
  }

  &:active {
    background-color: #dfe1e6;
  }
`;

const OptionsMenu = styled.div`
  display: ${(props) => (props.show ? "block" : "none")};
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  z-index: 100;
`;

const OptionItem = styled.div`
  padding: 8px;
  &:hover {
    background-color: #f0f0f0;
    cursor: pointer;
  }
`;
const HeaderInputBox = styled.div`
  display: flex;
  flex-direction: column;
`;

const CollapsedHeader = styled.div`
  background-color: #ebecf0;
  padding: 10px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 0 rgba(9, 30, 66, 0.25);
  /* margin-bottom: 8px; */
  /* rotate: 90deg; */
  /* border: 1px solid red; */
`;

const CollapsedTitle = styled.div`
  font-weight: bold;
  color: #5e6c84;
`;
